var Industry = "行业";
var Aerospace = "航空航天";
var Agriculture = "农业";
var Automotive = "汽车";
var Education = "教育";
var Gaming = "游戏";
var Government = "政府";
var Healthcare = "医疗保健";
var Hospitality = "酒店";
var Manufacturing = "生产制造";
var Mining = "矿业";
var Other = "其他";
var Retail = "零售";
var Telecommunications = "电信";
var Travel = "旅游";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "计算机与电子",
	"Consumer goods": "消费类产品",
	Education: Education,
	"Financial services": "金融服务",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "生命科学",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "营销和广告",
	"Media & entertainment": "媒体和娱乐",
	Mining: Mining,
	"Non-profit organization": "非营利性组织",
	"Oil & gas": "石油与天然气",
	Other: Other,
	"Power & utilities": "电力与公共事业",
	"Professional services": "专业服务",
	"Real estate & construction": "地产与建筑",
	Retail: Retail,
	"Software & internet": "软件与互联网",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "交通与物流",
	Travel: Travel,
	"Wholesale & distribution": "批发与分销"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
